import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import * as _moment from 'moment';
import {
  FantasyGame,
  FantasyGameQuery,
  FantasyGameService,
  LeaderboardType,
  LeaderboardV2Entry,
  LeaderboardV2Query,
  LeaderboardV2Service,
} from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgb-fantasy-game-play',
  templateUrl: './fantasy-game-play.component.html',
  styleUrl: './fantasy-game-play.component.scss',
})
export class FantasyGamePlayComponent implements OnInit {
  screenType = ScreenType;

  currentGames$: Observable<FantasyGame[]>;
  futureGames$: Observable<FantasyGame[]>;

  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  currentUser: LeaderboardV2Entry | undefined;

  constructor(
    private fantasyQuery: FantasyGameQuery,
    private leaderboardV2Service: LeaderboardV2Service,
    private leaderboardV2Query: LeaderboardV2Query,
    private fantasyGameService: FantasyGameService
  ) {}

  ngOnInit(): void {
    firstValueFrom(this.leaderboardV2Service.fetchLeaderboardV2(undefined, this.LeaderboardType)).then(() => {
      this.currentUser = this.leaderboardV2Query.getLeaderboardV2().find((entry) => entry.IsCurrentUser);
    });

    // fetch games
    this.fantasyGameService.fetchFantasyGamesV2(10, false, true).subscribe();

    this.currentGames$ = this.fantasyQuery.selectCurrentGames();

    // fallback trigger fetch for future games if no current
    this.currentGames$.pipe(take(1)).subscribe((games) => {
      if (!games.length || games.length === 0) {
        this.fantasyGameService.fetchFantasyGamesV2(10, false, true).subscribe();

        this.futureGames$ = this.fantasyQuery.selectAll();
      }
    });
  }
}
